import { render, staticRenderFns } from "./AdministradorTareas.vue?vue&type=template&id=7de2d458"
import script from "./AdministradorTareas.vue?vue&type=script&lang=js"
export * from "./AdministradorTareas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports